import { RestSerializer } from 'miragejs';

const ApplicationSerializer = RestSerializer.extend({
  root: false,
  embed: true,
  keyForAttribute(attr): string {
    return attr as string;
  },
  keyForEmbeddedRelationship(attributeName): string {
    return attributeName as string;
  },
});

export default {
  account: RestSerializer.extend({
    include: ['user_set', 'business_phones', 'billing_setting', 'twilio_configuration'],
    root: false,
    embed: true,
    keyForAttribute(attr: string): string {
      return attr;
    },
    keyForEmbeddedRelationship(attributeName: string): string {
      return `${attributeName}`;
    },
  }),
  user: RestSerializer.extend({
    include: ['account'],
    root: false,
    embed: true,
    keyForAttribute(attr: string): string {
      return attr;
    },
    keyForEmbeddedRelationship(attributeName: string): string {
      return `${attributeName}`;
    },
  }),
  industry: ApplicationSerializer,
  salesforceAccount: ApplicationSerializer,
  callRescueTestCall: ApplicationSerializer,
  businessPhone: ApplicationSerializer,
  parentAccount: ApplicationSerializer,
  billingSetting: ApplicationSerializer,
  twilioConfiguration: ApplicationSerializer,
};
